var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"t-rr-s-main-layout"},[_c('Header'),_c('div',{staticClass:"t-rr-s-main-wrapper"},[_c('SidebarSettings'),_c('main',{staticClass:"app-content"},[_c('div',{staticClass:"app-page"},[_c('router-view')],1)])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }